{
  "SHARED": {
    "MAINTENANCE": {
      "MESSAGE": "We hope to be back online very soon. Thank you for your patience and we apologize for any inconvenience caused."
    },
    "EVENT_TICKETS": {
      "FORM": {
        "PHONE": "Cell Number"
      }
    }
  }
}
